import { render } from "./MiniModalCustom.vue?vue&type=template&id=651b9fda"
import script from "./MiniModalCustom.vue?vue&type=script&lang=js"
export * from "./MiniModalCustom.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__